import { createSettingsListSection } from "../../SettingsListSection";
import ProjectService from "../../../../../models/ProjectService";

export const projectServiceDataComponentId = "dataComponentProjectService";

export default createSettingsListSection({
  dataComponentId: projectServiceDataComponentId,
  model: ProjectService,
  apiRoute: "project-services",
  label: "Service Type",
  pluralLabel: "Service Types",
  createModal: "CreateProjectService",
  editModal: "EditProjectService",
  editModalEntityKey: "projectService",
  permissions: ["manage-project-services"],
});
